import "./polyfills.js";
import "./robots.txt";

import "normalize.css";
import "styles/main.scss";

import React from "react";
import ReactDom from "react-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloLink } from "apollo-link";
import fragmentMatcher from "utils/charonFragmentMatcher";

import configureStore from "./store/configureStore";
import App from "./components/App";
import { setAuthToken } from "./actions/authDrawer";
import { getUserData } from "./actions/user";
import { getLocalItem } from "./utils/localdb";
import { apiLink, errorLink } from "utils/charonLinks";
import { IS_PROD } from "config/constants";

if (typeof window !== "undefined") {
  const preloadedState = window.__PRELOADED_STATE__;
  delete window.__PRELOADED_STATE__;

  const store = configureStore(preloadedState);

  const token = getLocalItem("authToken");
  if (token) {
    store.dispatch(setAuthToken(token))
      .then(() => store.dispatch(getUserData()));
  }

  const charonClient = new ApolloClient({
    link: ApolloLink.from([errorLink, apiLink()]),
    cache: new InMemoryCache({ fragmentMatcher }).restore(window.__APOLLO_STATE__),
    connectToDevTools: !IS_PROD,
  });

  // TODO: Remove this.
  const StreamRefactorProvider = STREAM_REFACTOR ? ApolloProvider : ({ children }) => children;

  const render = () => {
    (preloadedState ? ReactDom.hydrate : ReactDom.render)(
      <StreamRefactorProvider client={charonClient}>
        <HelmetProvider>
          <Provider store={store}>
            <App />
          </Provider>
        </HelmetProvider>
      </StreamRefactorProvider>
      , document.getElementById("app")
    );
  };

  if (module.hot) {
    module.hot.accept("./components/App", () => {
      render();
    });
  }

  render();
}
